import { render, staticRenderFns } from "./TemplateColumnButton.vue?vue&type=template&id=c0905f28&scoped=true&"
import script from "./TemplateColumnButton.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnButton.vue?vue&type=script&lang=js&"
import style0 from "../../Style/template-column-button.scss?vue&type=style&index=0&id=c0905f28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0905f28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0905f28')) {
      api.createRecord('c0905f28', component.options)
    } else {
      api.reload('c0905f28', component.options)
    }
    module.hot.accept("./TemplateColumnButton.vue?vue&type=template&id=c0905f28&scoped=true&", function () {
      api.rerender('c0905f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/ColumnContent/TemplateColumnButton.vue"
export default component.exports